import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedCurrency } from '@app/redux/currency/selectors';
import { useCustomer } from '@app/user';
import type { RootState } from '@app/redux/types';
import useCustomerBidOrAsk from './hooks/useCustomerBidOrAsk';

const useProductCustomerActivity = (product) => {
  const customer = useCustomer();
  const { currencyCode } = useSelector((state: RootState) => ({
    currencyCode: getSelectedCurrency(state),
  }));

  const getProductIdVar = product.id;

  const { res: bid } = useCustomerBidOrAsk(
    customer,
    currencyCode,
    getProductIdVar,
    true,
    'bid',
    product?.amount,
  );

  const { res: ask } = useCustomerBidOrAsk(
    customer,
    currencyCode,
    getProductIdVar,
    true,
    'ask',
    product?.amount,
  );

  const customerActivity = useMemo(
    () => [
      {
        ...bid,
        type: 'bid',
      },
      {
        ...ask,
        type: 'ask',
      },
    ],
    [bid, ask],
  );

  return { customerActivity };
};

export default useProductCustomerActivity;
